/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
import React from 'react'
import { useSearchParams } from 'react-router-dom'

const FilterModal = ({ filterPopup,setFilterPopup, categoryList, setCategoryList, filterState, setFilterState, handleFetchResources, setCurrentPage, setResourceList, setFilterApplied, filterApplied, setEmptyData }) => {
    const [searchParam, setSearchParam] = useSearchParams()
    const handleAdd = (item) => {
        setSearchParam({})
        const selectedItem = [...filterState]
        const index = selectedItem.indexOf(item.resource_category_id)
        if(index === -1){
            selectedItem.push(item.resource_category_id)
        }
        else {
            selectedItem.splice(index,1)
        }
        setFilterState(selectedItem)
    }

    const handleClearFilter = () => {
        setSearchParam({})
        setCurrentPage(1)
        setFilterState([])
        setResourceList([])
        setFilterApplied(!filterApplied)
        setFilterPopup(false)
        setEmptyData(false)
    }

    const handleApplyFilter = () => {
        setCurrentPage(1)
        setFilterApplied(!filterApplied)
        setFilterPopup(false)
        setResourceList([])
    }
    return (
        <div className={`modal fade fixed top-0 left-0 ${filterPopup ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[470px] mx-auto px-2.5" style={{ margin:'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[14px] rounded-t-md">
                        <h5 className="sm:text-xs4 text-xl font-semibold text-[#555259] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button 
                            type="button" className="absolute top-4 right-6" data-bs-dismiss="modal" aria-label="Close"
                            onClick={() => setFilterPopup(false)}>
                            <img src="/images/close.svg" alt="icon" className="w-[14px] h-[14px]"/>
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[30%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow text-start w-full" role="presentation">
                                    <a href="#pills-profileVertical " className="nav-link block text-base font-semibold text-[#AAA6AF] order active relative w-full rounded-lg" id="pills-size" data-bs-toggle="pill" data-bs-target="#pills-sizemm" role="tab"
                                        aria-controls="pills-sizemm" aria-selected="false" >Category
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[70%] max-h-[220px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className="tab-pane fade w-full show active overflow-auto max-h-[220px] custom-scrollbar1" id="pills-sizemm" role="tabpanel" aria-labelledby="pills-size">
                                    {categoryList.length > 0 && categoryList.map((item, index=0) => (
                                        <div className="ml-5 cursor-pointer" key={index}>
                                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                <input 
                                                    type="checkbox" 
                                                    id={index}
                                                    onChange={() => handleAdd(item)}
                                                    checked={filterState.includes(item.resource_category_id)}
                                                />
                                                <label htmlFor={index} className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">{item.name}</label>
                                            </div>                                          
                                        </div>
                                    ))}
                               
                                </div>
                            </div>   
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[30%] mr-5">
                                <button 
                                    type="button" 
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259] bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]" 
                                    data-bs-dismiss="modal" 
                                    aria-label="Close"
                                    onClick={() => handleClearFilter()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    type="button" 
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]" 
                                    data-bs-dismiss="modal" 
                                    aria-label="Close"
                                    onClick={() => handleApplyFilter()}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FilterModal
